import React from 'react';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import releveImage from 'images/mask-releve.png';
import { Grid } from '@material-ui/core';
import { Captions, ShortBody, SmallSectionHeader } from 'components/Typography';

export const StyledCaption = styled(({ reverse, ...otherProps }) => (
  <Captions {...otherProps} />
))`
  && {
    color: #9797af;
    font-size: 13px !important;
    margin-bottom: 6px;
    > span {
      margin-right: ${(props) => (props.reverse ? '6px' : '0px')};
    }
  }
`;
export const StyledShortBody = styled(ShortBody)`
  && {
    font-weight: 500;
    margin-bottom: 0;
    font-size: 13px;
  }
`;
export const StyledCaptionWhite = styled(Captions)`
  && {
    color: #ffffff;
    font-size: 13px !important;
    margin-bottom: 6px;
    line-height: 15px !important;
    text-align: left !important;
  }
`;

export const StyledPaper = styled(Paper)`
  && {
    border-radius: 6px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  }
`;
export const StyledPaperMask = styled(Paper)`
  && {
    border-radius: 6px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  }
`;
export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    line-height: 29px !important;
  }
`;
export const SizedSmallSectionHeader = styled(ShortBody)`
  && {
    margin-bottom: 15px;
    margin-left: 20px;
    margin-top: 15px;
    letter-spacing: 0;
    line-height: 19px !important;
  }
`;
export const WrapperSituation = styled(({ height, ...otherProps }) => (
  <div {...otherProps} />
))`
  height: 132px;
  background-image: url(${releveImage});
  background-size: 100% 100%;
  background-repeat: no-repeat;
`;
export const formStyle = {
  infoIcon: {
    cursor: 'pointer',
    color: '#EEC4C7',
    height: '20px',
    width: '20px',
    '&:hover': {
      borderRadius: '50%',
    },
  },
};
export const StyledGridLeft = styled(Grid)`
  margin-left: 3px;
  margin-top: 1px;
`;
